<div class="exception-body access">
    <img src="../../assets/images/logo-white.svg" alt="diamond-layout" class="logo" />

    <div class="exception-content">
        <div class="exception-title">ACCESS DENIED</div>
        <div class="exception-detail">You do not have the necessary permissions.</div>
        <a [routerLink]="['/']">Go to Dashboard</a>
    </div>
</div>
